/**
 *  Place for complete vendor modules
 */

require('./bootstrap');

require('./copy2clipboard');

require('jquery-ui/ui/widgets/autocomplete');
require('jquery-ui/ui/widgets/sortable');

require('bootstrap-table');

require('jstree');

//JS for selectfields
//require('chosen-js');


//global.moment = require('moment');
global.moment = require('moment-business-days');
moment.locale('de');

global.Pikaday = require('pikaday');

require('daterangepicker');

require('bootstrap4-notify');

require('tableexport.jquery.plugin');

require('print-js');

require('select2');
require('select2/dist/js/i18n/de');


// Statistiken mit JS
global.crossfilter = require('crossfilter2');
global.d3 = require('d3');
global.dc = require('dc');
global.c3 = require('c3');
require('./wordcloud');
require('./axis');

require('pivottable');
require('../../../node_modules/pivottable/dist/d3_renderers');
require('../../../node_modules/pivottable/dist/c3_renderers');
require('../../../node_modules/pivottable/dist/export_renderers');
require('../../../node_modules/pivottable/dist/pivot.de');

global.waitingDialog = require('bootstrap-waitingfor');

// Password Generator
//require('./passwordgenerator');
import strpbrk from './strpbrk';
import checkRules from './checkrules';
import password_generator from './passwordgenerator';
import replaceAll from './tools';
import markerclusterer from './markerclusterer';

window.strpbrk = strpbrk;

window.checkRules = checkRules;

window.password_generator = password_generator;

window.replaceAll = replaceAll;

//import adjustNavigationAfterResize from './nav.js';
//window.adjustNavigationAfterResize = adjustNavigationAfterResize;

// import autocomplete from './autocomplete';
//
// window.autocomplete = autocomplete;

window.markerclusterer = markerclusterer;


window.JSONEditor = require('@json-editor/json-editor').JSONEditor;

window.webauthn = require('../../../vendor/tk-world/fix-webauthn/resources/assets/js/webauthn');

require('../../../node_modules/bootstrap-table/dist/bootstrap-table.js');  // doesn't support extract ( "... export ..." )
require('../../../node_modules/bootstrap-table/dist/locale/bootstrap-table-de-DE.min.js');  // doesn't support extract ( "... export ..." )
require('../../../node_modules/bootstrap-table/dist/extensions/editable/bootstrap-table-editable.js');  // doesn't support extract ( "... export ..." )
require('../../../node_modules/bootstrap-table/dist/extensions/export/bootstrap-table-export.js');  // doesn't support extract ( "... export ..." )
require('../../../node_modules/bootstrap-table/dist/extensions/fixed-columns/bootstrap-table-fixed-columns.js');  // doesn't support extract ( "... export ..." )
//require('../../../node_modules/bootstrap-table/dist/extensions/group-by-v2/bootstrap-table-group-by.js');  // doesn't support extract ( "... export ..." )
require('../../../node_modules/x-editable/dist/bootstrap4-editable/js/bootstrap-editable.js');  // doesn't support extract ( "... export ..." )
require('../../../vendor/tk-world/fix-tree/resources/assets/js/fixTree.js'); // doesn't support extract ( "... export ..." )

$(function () {
    $.fn.select2.defaults.set("theme", "bootstrap4");

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    /**
     * Das Ding funktioniert nicht .... vielleicht sollte man es mit dem collapsed-Menu verbinden,
     * so dass man dort bei Bedarf Menüpunkte rein und rauspacken kann.
     adjustNavigationAfterResize();
     $(window).on('resize', _.debounce(function() {
     adjustNavigationAfterResize();
     }, 100));
     */
});

